<template>
    <li class="dropdown user user-menu" v-on:click="showOverlay" v-if="warmingTrays && warmingTrays.length">
        <ul class="warming-trays">
            <li v-for="warmingTray in warmingTrays">
                <span>{{warmingTray.name}} </span>
                <span class="warmingtraytoggle">
                    <onoff-toggle v-if="isActive(warmingTray)" theme="ios" width="22" height="12" onColor="#13BF11" v-model="trueValue" />
                    <onoff-toggle v-else-if="isFutureActive(warmingTray)" theme="ios" width="22" height="12" onColor="#F39C12"   v-model="trueValue" />
                    <onoff-toggle v-else theme="ios" width="22" height="12" v-model="falseValue" />
                </span>
                <!--onColor="onColor(warmingTray)"-->
            </li>
        </ul>
    </li>
</template>

<!--//<i v-if="isActive(warmingTray)" class="icon-checkmark"></i> <i v-if="!isActive(warmingTray)" class="icon-times"></i>-->

<script>

    import warmingTrayOverlay from '../components/WarmingTraysOverlay';
    import WarmingTrayRepository from '../repositories/WarmingTrayRepository';
    import timemanager from '../repositories/TimeManager';
    import Vue from 'vue';

    export default {

        name: 'WarmingTrays',

        components: { warmingTrayOverlay },

        data: function () {
            return {
                warmingTrays: WarmingTrayRepository.warmingTrays,
                trueValue: true,
                falseValue : false
            };
        },

        methods: {
            showOverlay: function (message) {
                // create orderDetail vue compnent
                // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
                var ComponentClass = Vue.extend(warmingTrayOverlay)
                // set properties
                var component = new ComponentClass(
                    {
                        propsData: {}// { warmingTrays : this.warmingTrays  }
                    }
                );
                component.$mount();

                // https://sweetalert2.github.io/#configuration
                this.$fire({
                    //title: "Bestelling #" + this.Order.orderNr,
                    html: '', // _orderDetail.$el.outerHTML,
                    width: '50rem',
                    padding: '0px',
                    showConfirmButton: false,
                    position: 'top',
                    customClass: {
                        container: 'order-detail'
                    },
                    onOpen: function (ell) {
                        ell.children[1].appendChild(component.$el);
                    }
                }).then(() => {
                    component.$destroy();
                });
            },

            isFutureActive: function (warmingTray) {
                return warmingTray.active && warmingTray.deactivateAt > timemanager.state.now;
            },

            isActive: function (warmingTray) {
                return warmingTray.active && warmingTray.activateAt < timemanager.state.now && warmingTray.deactivateAt > timemanager.state.now;
            }
        },

        computed: {

        }

    };

</script>

